import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

const InactivityDetector = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const modalTimerRef = useRef(null);
  const logoutTimerRef = useRef(null);
  const inactivityModalTime = 15 * 60 * 1000;
  const inactivityLogoutTime = 30 * 60 * 1000;
  const logOut = () => {
    console.log("Logging out due to inactivity...");
    dispatch({
      type: "accountData/logOut",
      payload: {},
    });
    dispatch({
      type: "gameData/logOut",
      payload: {},
    });
  };
  const resetTimers = () => {
    if (modalTimerRef.current) clearTimeout(modalTimerRef.current);
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    modalTimerRef.current = setTimeout(() => {
      setShowModal(true);
    }, inactivityModalTime);

    logoutTimerRef.current = setTimeout(() => {
      setShowModal(false); // Hide modal if logging out
      logOut();
    }, inactivityLogoutTime);
  };

  useEffect(() => {
    resetTimers();

    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimers));

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimers));
      if (modalTimerRef.current) clearTimeout(modalTimerRef.current);
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    };
  }, []);

  if (!showModal) return null;

  return (
    <>
      <div className="modaloverlay"></div>
      <div id="popup" className="popup" style={{ display: 'block' }}>
        <div className="popup-content">
          <p>Hey there! You've been inactive for a while. Do you want to continue?</p>
        </div>
        <button
          id="closeButton"
          type="button"
          className="mt-2 close-popup-button"
          onClick={() => {
            setShowModal(false);
            resetTimers();
          }}>
          Continue
        </button>
      </div>
    </>
  );
};

export default InactivityDetector;
